import React from "react";

export const Prices = (props) => {
  return (
    <div id="prices" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>PREMIOS</h2>
          <p>
            Premios entregados por nuestra administración.
          </p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  {" "}
                  <img src={d.icon} className={d.icon} alt="" />                  
                  <div className="service-desc">
                    <h3>{d.name}</h3>
                    <p>{d.date}</p>
                    <p>{d.price}</p>
                    <p className="price-amount">{d.amount}</p>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
